module.exports = __webpack_public_path__ + "static/media/comments.f0480dc9.svg";